export default __webpack_public_path__ + "static/media/ripple.4bda7a58.gif";